import { createContext, useState } from 'react';
import ConfirmationModal from '../components/ConfirmationModal';

type ShowModalProps = {
  title: string;
  message?: string;
  okBtnText?: string;
  cancelBtnText?: string;
  action?: () => void;
  show: boolean;
};
const initialModal: ShowModalProps = {
  title: '',
  message: '',
  show: false,
};

type ConfirmationContext = {
  modal: ShowModalProps;
  showModal: (modalProps: ShowModalProps) => void;
};
export const ConfirmationModalContext = createContext<ConfirmationContext>({
  modal: initialModal,
  showModal: () => undefined,
});

type ConfirmationProviderType = {
  children: React.ReactNode;
};
const ConfirmationProvider: React.FC<ConfirmationProviderType> = ({ children }) => {
  const [modal, setModal] = useState<ShowModalProps>({ title: '', show: false });

  const showModal = (modalProps: ShowModalProps) => {
    setModal({ ...modalProps });
  };

  return (
    <ConfirmationModalContext.Provider value={{ modal, showModal }}>
      {children}
      <ConfirmationModal />
    </ConfirmationModalContext.Provider>
  );
};
export default ConfirmationProvider;
